import React, { useState } from "react";
import { toast } from "sonner";
import { KeyRound, LogOut, Ban, CheckCircle2 } from "lucide-react";
import api, { formatError } from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export function MemberAccessControls({ member, onChanged }) {
  const [pw, setPw] = useState("");
  const [temp, setTemp] = useState("");
  const call = async (fn, ok) => {
    try { const r = await fn(); toast.success(ok); onChanged?.(); return r; }
    catch (e) { toast.error(formatError(e.response?.data?.detail)); }
  };
  const reset = async () => {
    const r = await call(() => api.post(`/admin/members/${member.id}/reset-password`, { new_password: pw || null }), "Password reset — member must sign in again");
    if (r?.data?.temporary_password) setTemp(r.data.temporary_password);
    setPw("");
  };
  const suspended = member.status === "suspended" || member.status === "inactive";
  return (
    <div className="space-y-3 rounded-xl border border-crimson/20 bg-parchment-card p-3" data-testid="member-access-controls">
      <p className="eyebrow text-crimson">Access controls</p>
      <div className="flex flex-wrap gap-2">
        {suspended
          ? <Button size="sm" className="bg-palm" onClick={() => call(() => api.post(`/admin/members/${member.id}/access?action=reactivate`), "Account reactivated")} data-testid="access-reactivate"><CheckCircle2 size={14} className="mr-1" /> Reactivate</Button>
          : <Button size="sm" variant="outline" className="text-destructive" onClick={() => call(() => api.post(`/admin/members/${member.id}/access?action=suspend`), "Account suspended — sessions revoked")} data-testid="access-suspend"><Ban size={14} className="mr-1" /> Suspend</Button>}
        <Button size="sm" variant="outline" onClick={() => call(() => api.post(`/admin/members/${member.id}/force-logout`), "All sessions signed out")} data-testid="access-force-logout"><LogOut size={14} className="mr-1" /> Force sign-out</Button>
      </div>
      <div>
        <Label className="text-xs">Reset password (leave blank to generate a temporary one)</Label>
        <div className="mt-1 flex gap-2">
          <Input type="text" placeholder="New password (min 8)" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="access-new-password" />
          <Button size="sm" variant="outline" onClick={reset} data-testid="access-reset-password"><KeyRound size={14} className="mr-1" /> Reset</Button>
        </div>
        {temp && <p className="mt-2 rounded-lg bg-gold-light p-2 text-xs" data-testid="access-temp-password">Temporary password: <span className="font-mono-accent font-bold select-all">{temp}</span> — share securely; member will be asked to change it.</p>}
      </div>
    </div>
  );
}
